"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.AuthScope = void 0;
var axios_1 = __importDefault(require("axios"));
var HttpError_1 = require("./HttpError");
var url_parse_1 = __importDefault(require("url-parse"));
var localization_1 = require("../../components/localization");
var CONTENT_TYPE_APPLICATION_JSON = 'application/json';
var RESPONSE_LOGIN_URL = 'signin?ReturnUrl';
var NOT_VALID_JSON = 'Response is not a valid JSON (Maybe token expired)';
var CONTENT_TYPE = 'Content-Type';
var CACHE_CONTROL = 'Cache-Control';
var BAD_REQUEST = 400;
var UNAUTHORIZED = 401;
var OK = 200;
var AUTHORIZATION_HEADER = 'Authorization';
var AuthScope;
(function (AuthScope) {
    AuthScope["api"] = "api";
})(AuthScope || (exports.AuthScope = AuthScope = {}));
var HttpWrapper = /** @class */ (function () {
    function HttpWrapper() {
    }
    //#region fetch methods
    HttpWrapper.fetch = function (url, options) {
        return __awaiter(this, void 0, void 0, function () {
            var response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (options.authScope) {
                            options.headers[AUTHORIZATION_HEADER] = window.auth.getHeader(options.authScope).Authorization;
                        }
                        return [4 /*yield*/, fetch(url, options)];
                    case 1:
                        response = _a.sent();
                        if (!(response.status === UNAUTHORIZED && options.authScope)) return [3 /*break*/, 4];
                        return [4 /*yield*/, this.refreshToken()];
                    case 2:
                        _a.sent();
                        options.headers[AUTHORIZATION_HEADER] = window.auth.getHeader(options.authScope).Authorization;
                        return [4 /*yield*/, fetch(url, options)];
                    case 3:
                        response = _a.sent();
                        _a.label = 4;
                    case 4: return [2 /*return*/, response];
                }
            });
        });
    };
    HttpWrapper.post = function (url, options) {
        return __awaiter(this, void 0, void 0, function () {
            var requestOptions, headers, method, _a, query, authScope, body, fullUrl, response, responseBody, e_1;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        requestOptions = __assign({ method: 'POST', headers: {} }, options);
                        headers = requestOptions.headers, method = requestOptions.method, _a = requestOptions.query, query = _a === void 0 ? {} : _a, authScope = requestOptions.authScope;
                        this.headersInitialize(headers, CONTENT_TYPE_APPLICATION_JSON);
                        this.addAuthHeader(headers, requestOptions);
                        this.addCacheControlHeaders(headers);
                        body = requestOptions.body && JSON.stringify(requestOptions.body);
                        fullUrl = this.addQueryPart(url, query);
                        return [4 /*yield*/, fetch(fullUrl, __assign({ method: method, headers: headers, body: body }, requestOptions.fetchOptions))];
                    case 1:
                        response = _b.sent();
                        if (!(response.status === UNAUTHORIZED && authScope)) return [3 /*break*/, 4];
                        return [4 /*yield*/, this.refreshToken()];
                    case 2:
                        _b.sent();
                        headers.Authorization = window.auth.getHeader(authScope).Authorization;
                        return [4 /*yield*/, fetch(fullUrl, __assign({ method: method, headers: headers, body: body }, requestOptions.fetchOptions))];
                    case 3:
                        response = _b.sent();
                        _b.label = 4;
                    case 4: return [4 /*yield*/, this.responseChecker(response, options)];
                    case 5:
                        _b.sent();
                        _b.label = 6;
                    case 6:
                        _b.trys.push([6, 8, , 9]);
                        return [4 /*yield*/, response.json()];
                    case 7:
                        responseBody = _b.sent();
                        if (!this.isLegacyPostResponse(responseBody)) {
                            return [2 /*return*/, responseBody];
                        }
                        if (responseBody.success) {
                            return [2 /*return*/, responseBody.data];
                        }
                        else {
                            throw new Error("Request failed. ".concat(responseBody.message));
                        }
                        return [3 /*break*/, 9];
                    case 8:
                        e_1 = _b.sent();
                        this.checkIsRedirectedToLogin(response);
                        return [2 /*return*/, null];
                    case 9: return [2 /*return*/];
                }
            });
        });
    };
    HttpWrapper.postFile = function (url, options) {
        return __awaiter(this, void 0, void 0, function () {
            var requestOptions, method, headers, body, authScope, response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        requestOptions = __assign({ method: 'POST', headers: {} }, options);
                        method = requestOptions.method, headers = requestOptions.headers, body = requestOptions.body, authScope = requestOptions.authScope;
                        this.addCacheControlHeaders(headers);
                        this.addAuthHeader(headers, requestOptions);
                        return [4 /*yield*/, fetch(url, { method: method, headers: headers, body: body })];
                    case 1:
                        response = _a.sent();
                        if (!(response.status === UNAUTHORIZED && authScope)) return [3 /*break*/, 4];
                        return [4 /*yield*/, this.refreshToken()];
                    case 2:
                        _a.sent();
                        headers.Authorization = window.auth.getHeader(authScope).Authorization;
                        return [4 /*yield*/, fetch(url, { method: method, headers: headers, body: body })];
                    case 3:
                        response = _a.sent();
                        _a.label = 4;
                    case 4: return [4 /*yield*/, this.responseChecker(response, options)];
                    case 5:
                        _a.sent();
                        return [2 /*return*/, response.json()];
                }
            });
        });
    };
    HttpWrapper.get = function (url, options) {
        return __awaiter(this, void 0, void 0, function () {
            var requestOptions, method, headers, _a, useCacheBuster, _b, query, authScope, fullUrl, response, e_2;
            return __generator(this, function (_c) {
                switch (_c.label) {
                    case 0:
                        requestOptions = __assign({ method: 'GET', headers: {} }, options);
                        method = requestOptions.method, headers = requestOptions.headers, _a = requestOptions.useCacheBuster, useCacheBuster = _a === void 0 ? true : _a, _b = requestOptions.query, query = _b === void 0 ? {} : _b, authScope = requestOptions.authScope;
                        this.headersInitialize(headers, CONTENT_TYPE_APPLICATION_JSON);
                        if (useCacheBuster) {
                            query._ = Date.now();
                            this.addCacheControlHeaders(headers);
                        }
                        this.addAuthHeader(headers, requestOptions);
                        fullUrl = this.addQueryPart(url, query);
                        return [4 /*yield*/, fetch(fullUrl, __assign({ method: method, headers: headers }, requestOptions.fetchOptions))];
                    case 1:
                        response = _c.sent();
                        if (!(response.status === UNAUTHORIZED && authScope)) return [3 /*break*/, 4];
                        return [4 /*yield*/, this.refreshToken()];
                    case 2:
                        _c.sent();
                        headers.Authorization = window.auth.getHeader(authScope).Authorization;
                        return [4 /*yield*/, fetch(fullUrl, __assign({ method: method, headers: headers }, requestOptions.fetchOptions))];
                    case 3:
                        response = _c.sent();
                        _c.label = 4;
                    case 4: return [4 /*yield*/, this.responseChecker(response, options)];
                    case 5:
                        _c.sent();
                        _c.label = 6;
                    case 6:
                        _c.trys.push([6, 8, , 9]);
                        return [4 /*yield*/, response.json()];
                    case 7: return [2 /*return*/, _c.sent()];
                    case 8:
                        e_2 = _c.sent();
                        this.checkIsRedirectedToLogin(response);
                        return [2 /*return*/, null];
                    case 9: return [2 /*return*/];
                }
            });
        });
    };
    HttpWrapper.getFile = function (url, options) {
        return __awaiter(this, void 0, void 0, function () {
            var requestOptions, method, headers, _a, useCacheBuster, _b, query, authScope, fullUrl, response;
            return __generator(this, function (_c) {
                switch (_c.label) {
                    case 0:
                        requestOptions = __assign({ method: 'GET', headers: {} }, options);
                        method = requestOptions.method, headers = requestOptions.headers, _a = requestOptions.useCacheBuster, useCacheBuster = _a === void 0 ? true : _a, _b = requestOptions.query, query = _b === void 0 ? {} : _b, authScope = requestOptions.authScope;
                        this.headersInitialize(headers, CONTENT_TYPE_APPLICATION_JSON);
                        this.addAuthHeader(headers, requestOptions);
                        if (useCacheBuster) {
                            query._ = Date.now();
                            this.addCacheControlHeaders(headers);
                        }
                        fullUrl = this.addQueryPart(url, query);
                        return [4 /*yield*/, fetch(fullUrl, { method: method, headers: headers })];
                    case 1:
                        response = _c.sent();
                        if (!(response.status === UNAUTHORIZED && authScope)) return [3 /*break*/, 4];
                        return [4 /*yield*/, this.refreshToken()];
                    case 2:
                        _c.sent();
                        headers.Authorization = window.auth.getHeader(authScope).Authorization;
                        return [4 /*yield*/, fetch(fullUrl, { method: method, headers: headers })];
                    case 3:
                        response = _c.sent();
                        _c.label = 4;
                    case 4: return [4 /*yield*/, this.responseChecker(response, options)];
                    case 5:
                        _c.sent();
                        return [2 /*return*/, response.blob()];
                }
            });
        });
    };
    HttpWrapper.getCsv = function (url, options) {
        return __awaiter(this, void 0, void 0, function () {
            var requestOptions, method, headers, _a, useCacheBuster, _b, query, authScope, fullUrl, response, entityTitle, blob;
            return __generator(this, function (_c) {
                switch (_c.label) {
                    case 0:
                        requestOptions = __assign({ method: 'GET', headers: {} }, options);
                        method = requestOptions.method, headers = requestOptions.headers, _a = requestOptions.useCacheBuster, useCacheBuster = _a === void 0 ? true : _a, _b = requestOptions.query, query = _b === void 0 ? {} : _b, authScope = requestOptions.authScope;
                        this.headersInitialize(headers, CONTENT_TYPE_APPLICATION_JSON);
                        this.addAuthHeader(headers, requestOptions);
                        if (useCacheBuster) {
                            query._ = Date.now();
                            this.addCacheControlHeaders(headers);
                        }
                        fullUrl = this.addQueryPart(url, query);
                        return [4 /*yield*/, fetch(fullUrl, { method: method, headers: headers })];
                    case 1:
                        response = _c.sent();
                        if (!(response.status === UNAUTHORIZED && authScope)) return [3 /*break*/, 4];
                        return [4 /*yield*/, this.refreshToken()];
                    case 2:
                        _c.sent();
                        headers.Authorization = window.auth.getHeader(authScope).Authorization;
                        return [4 /*yield*/, fetch(fullUrl, { method: method, headers: headers })];
                    case 3:
                        response = _c.sent();
                        _c.label = 4;
                    case 4: return [4 /*yield*/, this.responseChecker(response, options)];
                    case 5:
                        _c.sent();
                        entityTitle = response.headers.get('X-Entity-Title');
                        return [4 /*yield*/, response.blob()];
                    case 6:
                        blob = _c.sent();
                        return [2 /*return*/, {
                                blob: blob,
                                entityTitle: entityTitle
                            }];
                }
            });
        });
    };
    HttpWrapper.delete = function (url, options) {
        return __awaiter(this, void 0, void 0, function () {
            var requestOptions, method, headers, _a, query, authScope, body, fullUrl, response, e_3;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        requestOptions = __assign({ method: 'DELETE', headers: {} }, options);
                        method = requestOptions.method, headers = requestOptions.headers, _a = requestOptions.query, query = _a === void 0 ? {} : _a, authScope = requestOptions.authScope;
                        this.headersInitialize(headers, CONTENT_TYPE_APPLICATION_JSON);
                        this.addAuthHeader(headers, requestOptions);
                        this.addCacheControlHeaders(headers);
                        body = requestOptions.body && JSON.stringify(requestOptions.body);
                        fullUrl = this.addQueryPart(url, query);
                        return [4 /*yield*/, fetch(fullUrl, __assign({ method: method, headers: headers, body: body }, requestOptions.fetchOptions))];
                    case 1:
                        response = _b.sent();
                        if (!(response.status === UNAUTHORIZED && authScope)) return [3 /*break*/, 4];
                        return [4 /*yield*/, this.refreshToken()];
                    case 2:
                        _b.sent();
                        headers.Authorization = window.auth.getHeader(authScope).Authorization;
                        return [4 /*yield*/, fetch(fullUrl, __assign({ method: method, headers: headers, body: body }, requestOptions.fetchOptions))];
                    case 3:
                        response = _b.sent();
                        _b.label = 4;
                    case 4: return [4 /*yield*/, this.responseChecker(response, options)];
                    case 5:
                        _b.sent();
                        _b.label = 6;
                    case 6:
                        _b.trys.push([6, 8, , 9]);
                        return [4 /*yield*/, response.json()];
                    case 7: return [2 /*return*/, _b.sent()];
                    case 8:
                        e_3 = _b.sent();
                        this.checkIsRedirectedToLogin(response);
                        return [2 /*return*/, null];
                    case 9: return [2 /*return*/];
                }
            });
        });
    };
    /**
     * Returns raw Response object
     */
    HttpWrapper.put = function (url, options) {
        return __awaiter(this, void 0, void 0, function () {
            var requestOptions, headers, method, authScope, body, response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        requestOptions = __assign({ method: 'PUT', headers: {} }, options);
                        headers = requestOptions.headers, method = requestOptions.method, authScope = requestOptions.authScope;
                        this.headersInitialize(headers, CONTENT_TYPE_APPLICATION_JSON);
                        this.addAuthHeader(headers, requestOptions);
                        this.addCacheControlHeaders(headers);
                        body = requestOptions.body && JSON.stringify(requestOptions.body);
                        return [4 /*yield*/, fetch(url, __assign({ method: method, headers: headers, body: body }, requestOptions.fetchOptions))];
                    case 1:
                        response = _a.sent();
                        if (!(response.status === UNAUTHORIZED && authScope)) return [3 /*break*/, 4];
                        return [4 /*yield*/, this.refreshToken()];
                    case 2:
                        _a.sent();
                        headers.Authorization = window.auth.getHeader(authScope).Authorization;
                        return [4 /*yield*/, fetch(url, __assign({ method: method, headers: headers, body: body }, requestOptions.fetchOptions))];
                    case 3:
                        response = _a.sent();
                        _a.label = 4;
                    case 4: return [4 /*yield*/, this.responseChecker(response, options)];
                    case 5:
                        _a.sent();
                        return [2 /*return*/, response];
                }
            });
        });
    };
    /**
     * Returns typed parsed JSON data
     */
    HttpWrapper.putTyped = function (url, options) {
        return __awaiter(this, void 0, void 0, function () {
            var response, e_4;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.put(url, options)];
                    case 1:
                        response = _a.sent();
                        _a.label = 2;
                    case 2:
                        _a.trys.push([2, 4, , 5]);
                        return [4 /*yield*/, response.json()];
                    case 3: return [2 /*return*/, _a.sent()];
                    case 4:
                        e_4 = _a.sent();
                        this.checkIsRedirectedToLogin(response);
                        return [2 /*return*/, null];
                    case 5: return [2 /*return*/];
                }
            });
        });
    };
    /**
     * Returns raw Response object
     */
    HttpWrapper.patch = function (url, options) {
        return __awaiter(this, void 0, void 0, function () {
            var _a, headers, body, fetchOptions, authScope, response;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        _a = options.headers, headers = _a === void 0 ? {} : _a, body = options.body, fetchOptions = options.fetchOptions, authScope = options.authScope;
                        this.headersInitialize(headers, CONTENT_TYPE_APPLICATION_JSON);
                        this.addAuthHeader(headers, options);
                        this.addCacheControlHeaders(headers);
                        return [4 /*yield*/, fetch(url, __assign({ method: 'PATCH', headers: headers, body: JSON.stringify(body || {}) }, fetchOptions))];
                    case 1:
                        response = _b.sent();
                        if (!(response.status === UNAUTHORIZED && authScope)) return [3 /*break*/, 4];
                        return [4 /*yield*/, this.refreshToken()];
                    case 2:
                        _b.sent();
                        headers.Authorization = window.auth.getHeader(authScope).Authorization;
                        return [4 /*yield*/, fetch(url, __assign({ method: 'PATCH', headers: headers, body: JSON.stringify(body || {}) }, fetchOptions))];
                    case 3:
                        response = _b.sent();
                        _b.label = 4;
                    case 4: return [4 /*yield*/, this.responseChecker(response, options)];
                    case 5:
                        _b.sent();
                        return [2 /*return*/, response];
                }
            });
        });
    };
    /**
     * Returns typed parsed JSON data
     */
    HttpWrapper.patchTyped = function (url, options) {
        return __awaiter(this, void 0, void 0, function () {
            var response, e_5;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.patch(url, options)];
                    case 1:
                        response = _a.sent();
                        _a.label = 2;
                    case 2:
                        _a.trys.push([2, 4, , 5]);
                        return [4 /*yield*/, response.json()];
                    case 3: return [2 /*return*/, _a.sent()];
                    case 4:
                        e_5 = _a.sent();
                        this.checkIsRedirectedToLogin(response);
                        return [2 /*return*/, null];
                    case 5: return [2 /*return*/];
                }
            });
        });
    };
    //#endregion
    //#region axios methods
    HttpWrapper.axios = function (config) {
        var client = this.getAxiosInstance(config.url, config.authScope);
        return client.request(config);
    };
    HttpWrapper.uploadFile = function (url, options) {
        return __awaiter(this, void 0, void 0, function () {
            var headers, client, response, error_1;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 2, , 3]);
                        headers = options.headers;
                        if (!headers) {
                            headers = {};
                        }
                        this.addAuthHeader(headers, options);
                        client = this.getAxiosInstance(url, options.authScope);
                        return [4 /*yield*/, client.request({
                                method: options.axiosRequestConfigs.method || 'POST',
                                url: url,
                                data: options.body,
                                headers: headers,
                                onUploadProgress: options.axiosRequestConfigs.onUploadProgress,
                                cancelToken: options.axiosRequestConfigs.cancelToken
                            })];
                    case 1:
                        response = _a.sent();
                        return [2 /*return*/, response.data];
                    case 2:
                        error_1 = _a.sent();
                        if (!axios_1.default.isCancel(error_1)) {
                            throw error_1;
                        }
                        return [3 /*break*/, 3];
                    case 3: return [2 /*return*/, null];
                }
            });
        });
    };
    HttpWrapper.generateCancelToken = function (cancelTokenHandler) {
        return new axios_1.default.CancelToken(cancelTokenHandler);
    };
    //#endregion
    HttpWrapper.addQueryPart = function (url, query) {
        if (query === void 0) { query = {}; }
        var parsedUrl = (0, url_parse_1.default)(url, true);
        parsedUrl.set('query', __assign(__assign({}, parsedUrl.query), query));
        return parsedUrl.toString();
    };
    HttpWrapper.postFullResponse = function (url, options) {
        return __awaiter(this, void 0, void 0, function () {
            var requestOptions, headers, method, _a, query, authScope, body, fullUrl, response, error_2;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        requestOptions = __assign({ method: 'POST', headers: {} }, options);
                        headers = requestOptions.headers, method = requestOptions.method, _a = requestOptions.query, query = _a === void 0 ? {} : _a, authScope = requestOptions.authScope;
                        body = requestOptions.body;
                        this.headersInitialize(headers, CONTENT_TYPE_APPLICATION_JSON);
                        this.addAuthHeader(headers, requestOptions);
                        this.addCacheControlHeaders(headers);
                        if (body) {
                            body = JSON.stringify(body);
                        }
                        fullUrl = this.addQueryPart(url, query);
                        return [4 /*yield*/, fetch(fullUrl, __assign({ method: method, headers: headers, body: body }, requestOptions.fetchOptions))];
                    case 1:
                        response = _b.sent();
                        if (!(response.status === UNAUTHORIZED && authScope)) return [3 /*break*/, 4];
                        return [4 /*yield*/, this.refreshToken()];
                    case 2:
                        _b.sent();
                        headers.Authorization = window.auth.getHeader(authScope).Authorization;
                        return [4 /*yield*/, fetch(fullUrl, __assign({ method: method, headers: headers, body: body }, requestOptions.fetchOptions))];
                    case 3:
                        response = _b.sent();
                        _b.label = 4;
                    case 4:
                        _b.trys.push([4, 6, , 7]);
                        return [4 /*yield*/, this.responseChecker(response, options)];
                    case 5:
                        _b.sent();
                        return [2 /*return*/, response];
                    case 6:
                        error_2 = _b.sent();
                        this.checkIsRedirectedToLogin(response);
                        throw error_2;
                    case 7: return [2 /*return*/];
                }
            });
        });
    };
    HttpWrapper.getFullResponse = function (url, options) {
        return __awaiter(this, void 0, void 0, function () {
            var requestOptions, method, headers, _a, useCacheBuster, _b, query, authScope, fullUrl, response, error_3;
            return __generator(this, function (_c) {
                switch (_c.label) {
                    case 0:
                        requestOptions = __assign({ method: 'GET', headers: {} }, options);
                        method = requestOptions.method, headers = requestOptions.headers, _a = requestOptions.useCacheBuster, useCacheBuster = _a === void 0 ? true : _a, _b = requestOptions.query, query = _b === void 0 ? {} : _b, authScope = requestOptions.authScope;
                        this.headersInitialize(headers, CONTENT_TYPE_APPLICATION_JSON);
                        if (useCacheBuster) {
                            query._ = Date.now();
                            this.addCacheControlHeaders(headers);
                        }
                        this.addAuthHeader(headers, requestOptions);
                        fullUrl = this.addQueryPart(url, query);
                        return [4 /*yield*/, fetch(fullUrl, __assign({ method: method, headers: headers }, requestOptions.fetchOptions))];
                    case 1:
                        response = _c.sent();
                        if (!(response.status === UNAUTHORIZED && authScope)) return [3 /*break*/, 4];
                        return [4 /*yield*/, this.refreshToken()];
                    case 2:
                        _c.sent();
                        headers.Authorization = window.auth.getHeader(authScope).Authorization;
                        return [4 /*yield*/, fetch(fullUrl, __assign({ method: method, headers: headers }, requestOptions.fetchOptions))];
                    case 3:
                        response = _c.sent();
                        _c.label = 4;
                    case 4:
                        _c.trys.push([4, 6, , 7]);
                        return [4 /*yield*/, this.responseChecker(response, options)];
                    case 5:
                        _c.sent();
                        return [2 /*return*/, response];
                    case 6:
                        error_3 = _c.sent();
                        this.checkIsRedirectedToLogin(response);
                        throw error_3;
                    case 7: return [2 /*return*/];
                }
            });
        });
    };
    HttpWrapper.isSignInLocation = function () {
        return window.location.pathname === this.signInRedirectUrl;
    };
    HttpWrapper.headersInitialize = function (headers, contentType) {
        var _a;
        Object.assign(headers, (_a = {}, _a[CONTENT_TYPE] = contentType, _a), headers);
    };
    HttpWrapper.addAuthHeader = function (headers, options) {
        var authScope = options.authScope, bearerToken = options.bearerToken;
        if (bearerToken) {
            headers.Authorization = "Bearer ".concat(bearerToken);
            return;
        }
        if (!headers.Authorization && window.auth && authScope) {
            headers.Authorization = window.auth.getHeader(authScope).Authorization;
        }
    };
    HttpWrapper.addCacheControlHeaders = function (headers) {
        headers[CACHE_CONTROL] = !headers[CACHE_CONTROL] ? 'no-cache' : headers[CACHE_CONTROL];
        headers.Pragma = !headers.Pragma ? 'no-cache' : headers.Pragma;
        headers.Expires = !headers.Expires ? 0 : headers.Expires;
    };
    HttpWrapper.responseChecker = function (response, options) {
        return __awaiter(this, void 0, void 0, function () {
            var errorMessage, responseBody, e_6;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if ((response === null || response === void 0 ? void 0 : response.status) < BAD_REQUEST) {
                            return [2 /*return*/];
                        }
                        if (!((response === null || response === void 0 ? void 0 : response.status) === UNAUTHORIZED && !this.isSignInLocation())) return [3 /*break*/, 2];
                        return [4 /*yield*/, this.userUnauthorizedHandler(options)];
                    case 1:
                        _a.sent();
                        _a.label = 2;
                    case 2:
                        _a.trys.push([2, 4, , 6]);
                        return [4 /*yield*/, (response === null || response === void 0 ? void 0 : response.clone().json())];
                    case 3:
                        responseBody = _a.sent();
                        errorMessage = (responseBody === null || responseBody === void 0 ? void 0 : responseBody.resourceKey) ? (0, localization_1.localize)(responseBody.resourceKey) : responseBody === null || responseBody === void 0 ? void 0 : responseBody.message;
                        return [3 /*break*/, 6];
                    case 4:
                        e_6 = _a.sent();
                        return [4 /*yield*/, (response === null || response === void 0 ? void 0 : response.clone().text())];
                    case 5:
                        errorMessage = _a.sent();
                        return [3 /*break*/, 6];
                    case 6:
                        if (!errorMessage) {
                            errorMessage = (0, localization_1.localize)('anErrorOccurred');
                        }
                        throw new HttpError_1.HttpError(errorMessage, response === null || response === void 0 ? void 0 : response.status, responseBody);
                }
            });
        });
    };
    HttpWrapper.userUnauthorizedHandler = function (options) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (!(options === null || options === void 0 ? void 0 : options.unauthorizedHandler)) return [3 /*break*/, 2];
                        return [4 /*yield*/, options.unauthorizedHandler()];
                    case 1:
                        _a.sent();
                        return [3 /*break*/, 4];
                    case 2:
                        if (!this.unauthorizedHandler) return [3 /*break*/, 4];
                        return [4 /*yield*/, this.unauthorizedHandler()];
                    case 3:
                        _a.sent();
                        _a.label = 4;
                    case 4:
                        if (!this.disableRedirects && !(options === null || options === void 0 ? void 0 : options.disableRedirects)) {
                            window.location.replace(this.signInRedirectUrl);
                        }
                        return [2 /*return*/];
                }
            });
        });
    };
    HttpWrapper.checkIsRedirectedToLogin = function (response) {
        if ((response === null || response === void 0 ? void 0 : response.status) === OK && (response === null || response === void 0 ? void 0 : response.url.includes(RESPONSE_LOGIN_URL)) && (response === null || response === void 0 ? void 0 : response.redirected)) {
            window.location.replace(this.signInRedirectUrl);
            throw new Error(NOT_VALID_JSON);
        }
    };
    HttpWrapper.isLegacyPostResponse = function (response) {
        if (typeof response !== 'object') {
            return false;
        }
        if (typeof response.success !== 'boolean') {
            return false;
        }
        if (typeof response.data === 'undefined' && typeof response.message !== 'string') {
            return false;
        }
        return true;
    };
    HttpWrapper.getAxiosInstance = function (url, authScope) {
        var _this = this;
        var client = axios_1.default.create({
            baseURL: url
        });
        client.interceptors.request.use(function (config) {
            if (authScope) {
                config.headers[AUTHORIZATION_HEADER] = window.auth.getHeader(authScope).Authorization;
            }
            return config;
        }, function (error) { return Promise.reject(error); });
        client.interceptors.response.use(function (responseAxios) { return responseAxios; }, function (error) { return __awaiter(_this, void 0, void 0, function () {
            var refreshError_1;
            var _a;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        if (!(((_a = error.response) === null || _a === void 0 ? void 0 : _a.status) === UNAUTHORIZED && !error.config._retry && authScope)) return [3 /*break*/, 4];
                        error.config._retry = true;
                        _b.label = 1;
                    case 1:
                        _b.trys.push([1, 3, , 4]);
                        return [4 /*yield*/, this.refreshToken()];
                    case 2:
                        _b.sent();
                        error.config.headers[AUTHORIZATION_HEADER] =
                            window.auth.getHeader(authScope).Authorization;
                        return [2 /*return*/, client.request(error.config)];
                    case 3:
                        refreshError_1 = _b.sent();
                        return [2 /*return*/, Promise.reject(refreshError_1)];
                    case 4: return [2 /*return*/, Promise.reject(error)];
                }
            });
        }); });
        return client;
    };
    HttpWrapper.refreshToken = function () {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, window.auth.login()];
                    case 1:
                        _a.sent();
                        return [2 /*return*/];
                }
            });
        });
    };
    HttpWrapper.signInRedirectUrl = '/signin';
    HttpWrapper.disableRedirects = false;
    HttpWrapper.scope = AuthScope;
    HttpWrapper.unauthorizedHandler = function () {
        var _a;
        (_a = window.auth) === null || _a === void 0 ? void 0 : _a.logout();
    };
    return HttpWrapper;
}());
exports.default = HttpWrapper;
